module.exports = __webpack_public_path__ + "img/urn-black.a820a051.svg";